'use client';

import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTRPC } from '@/lib/trpc/provider';

const DEFAULTS = {
  primaryColor: '#1e306e',
  secondaryColor: '#fc800a',
  tertiaryColor: '#fcf7ee',
  accentColor: '#2fa5fb',
};

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const trpc = useTRPC();
  const { data: branding } = useQuery({
    ...trpc.platformSettings.getBranding.queryOptions(),
    staleTime: 5 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    const config = branding ?? DEFAULTS;
    const root = document.documentElement.style;

    // Set semantic theme vars
    root.setProperty('--eifo-primary', config.primaryColor);
    root.setProperty('--eifo-secondary', config.secondaryColor);
    root.setProperty('--eifo-tertiary', config.tertiaryColor);
    root.setProperty('--eifo-accent', config.accentColor);

    // Legacy aliases for backward compatibility
    root.setProperty('--eifo-orange', config.secondaryColor);
    root.setProperty('--eifo-bg-light', config.tertiaryColor);
  }, [branding]);

  return <>{children}</>;
}
